"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Type of list (numbering or bullet)
 */
var ListType;
(function (ListType) {
    /**
     * None list type
     * It means this is not a list
     */
    ListType[ListType["None"] = 0] = "None";
    /**
     * Ordered List type (numbering list)
     * Represented by "OL" tag
     */
    ListType[ListType["Ordered"] = 1] = "Ordered";
    /**
     * Unordered List type (bullet list)
     * Represented by "UL" tag
     */
    ListType[ListType["Unordered"] = 2] = "Unordered";
})(ListType = exports.ListType || (exports.ListType = {}));
//# sourceMappingURL=ListType.js.map